export default "__VITE_ASSET__df3c0c01__"